import { useDispatch, useSelector } from 'react-redux';

import EventsListDetailsComponent from '../components/EventsDetailsListComponent';

import { getBuildingsForFilter } from '../../Building/actionCreators';
import { getEvents } from '../actions';

const LIST_KEY = 'eventsDetails';

const EventsDetailsContainer = () => {
  const dispatch = useDispatch();
  const store = useSelector((state) => state);

  const { events, lists, buildings, common } = store;
  const listParams = lists?.[LIST_KEY] ?? {};
  const items = events?.events;
  const currentUserId = common?.currentUser?.id;

  const getItems = () => getEvents(dispatch, listParams);
  const onLoad = () => getBuildingsForFilter(dispatch);

  return (
    <EventsListDetailsComponent
      listParams={listParams}
      items={items}
      getItems={getItems}
      onLoad={onLoad}
      listKey={LIST_KEY}
      buildings={buildings}
      currentUserId={currentUserId}
    />
  );
};

export default EventsDetailsContainer;
